import { defineStore } from "pinia";
import { ProfileAdministrationAPI } from "../api";

// Every project wizard asks on mount, and the products view renders one per product card: callers
// share the request that is already in flight instead of each firing their own.
let pendingLoad: Promise<void> | null = null;

export const useProductsWithRolesStore = defineStore("productsWithRoles", {
    state: () => ({
        productsWithRoles: [] as string[],
        loaded: false,
    }),
    actions: {
        async ensureLoaded() {
            if (this.loaded) return;
            pendingLoad ??= ProfileAdministrationAPI.getProductsWithRoles()
                .then((result) => {
                    this.productsWithRoles = Array.isArray(result) ? result : [];
                    this.loaded = true;
                })
                .finally(() => {
                    pendingLoad = null;
                });
            return pendingLoad;
        },
        productHasRoles(productNo: string): boolean {
            return this.productsWithRoles.includes(productNo);
        },
    },
});
